module.exports = __webpack_public_path__ + "img/z06.6b4c93c0.jpg";